import { ApprovalReviewView, type ApprovalReviewRecord } from "@medicorepay/ui";
import { useSearchParams } from "react-router-dom";
import apiClient from "../../lib/api-client";

export function ApprovalCenterPage() {
  const [searchParams] = useSearchParams();
  return (
    <ApprovalReviewView
      initialRequestId={searchParams.get("requestId") ?? ""}
      loadApproval={async (requestId) =>
        (
          await apiClient.get<ApprovalReviewRecord>(
            `/security/approvals/${encodeURIComponent(requestId)}/review`,
          )
        ).data
      }
      reviewApproval={async (requestId, decision, reason, idempotencyKey) =>
        (
          await apiClient.post<ApprovalReviewRecord>(
            `/security/approvals/${encodeURIComponent(requestId)}/decisions`,
            { decision, reason },
            { headers: { "Idempotency-Key": idempotencyKey } },
          )
        ).data
      }
    />
  );
}
